// https://github.com/SheetJS/sheetjs/issues/817#issuecomment-331605640
export const exportXlsx = async ({
  data,
  name,
}: {
  data: any[];
  name?: string;
}): Promise<void> => {
  const { default: xlsx } = await import('xlsx');
  const ws = xlsx.utils.json_to_sheet(data);
  const wb = xlsx.utils.book_new();
  xlsx.utils.book_append_sheet(wb, ws);
  xlsx.writeFile(wb, `${name ?? 'download'}.xlsx`);
};
